/**
 * Legacy `goTo('page-key')` ids from static HTML → React Router paths.
 * Also used for onclick handlers in profile HTML injected via dangerouslySetInnerHTML.
 */

/** @type {readonly string[]} */
export const PRACTICE_AREA_SLUGS = [
  'corporate',
  'licensing',
  'labour',
  'privacy',
  'realestate',
  'disputes',
];

/** @param {string} slug */
export function practiceAreaGoToKey(slug) {
  return `pa-${slug}`;
}

/** @param {string} slug */
export function pathForPracticeArea(slug) {
  return `/practices/${slug}`;
}

/** @param {string} slug */
export function profileGoToKey(slug) {
  return `profile-${slug}`;
}

/** @param {string} slug */
export function pathForProfile(slug) {
  return `/team/${slug}`;
}

/** @type {Record<string, string>} */
export const GOTO_PAGE_PATHS = {
  home: '/',
  practices: '/practices',
  team: '/team',
  toolkits: '/toolkits',
  updates: '/updates',
  contact: '/contact',
  ...Object.fromEntries(
    PRACTICE_AREA_SLUGS.map((slug) => [
      practiceAreaGoToKey(slug),
      pathForPracticeArea(slug),
    ]),
  ),
};

/** Alias used by React pages (same map as legacy goTo keys). */
export const PAGE_PATHS = GOTO_PAGE_PATHS;

/**
 * @param {string} pageKey e.g. `pa-corporate`, `profile-diep`, `home`
 * @returns {string} path or `/` if unknown
 */
export function pathForGoTo(pageKey) {
  if (!pageKey || typeof pageKey !== 'string') return '/';
  if (pageKey.startsWith('profile-')) {
    return pathForProfile(pageKey.slice('profile-'.length));
  }
  if (pageKey.startsWith('pa-')) {
    const slug = pageKey.slice('pa-'.length);
    if (slug) return pathForPracticeArea(slug);
  }
  return GOTO_PAGE_PATHS[pageKey] ?? '/';
}

/** @param {string} pageKey */
export function pathForPage(pageKey) {
  return pathForGoTo(pageKey);
}
